import {connect} from 'react-redux';
import ScholarshipProgramDropdown from './ScholarshipProgramDropdown';
import {fetchScholarshipPrograms} from 'src/redux/admin/actions/universities';

export default connect(null, {fetchScholarshipPrograms})(ScholarshipProgramDropdown);
